<template>
  <div class="detalle-operacion-panel">
    <DxTabPanel height="95%" tabs-position="top" icon-position="left">
      <DxItem :key="1" :title="tituloTab1" class="tab-item" :disabled="false" icon="fa-regular fa-id-card">
        <operaciones-resumen-tab-titular :model="model" :tramite="tramite"></operaciones-resumen-tab-titular>
      </DxItem>
      <DxItem :key="2" :title="tituloTab2" class="tab-item" :disabled="false" icon="fa-regular fa-house">
        <operaciones-resumen-tab-suministro :model="model" :tramite="tramite"></operaciones-resumen-tab-suministro>
      </DxItem>
      <DxItem :key="3" :title="tituloTab3" class="tab-item" :disabled="false" icon="fa-regular fa-credit-card">
        <operaciones-resumen-tab-facturacion :model="model" :tramite="tramite"></operaciones-resumen-tab-facturacion>
      </DxItem>
      <DxItem :key="4" :title="tituloTab4" class="tab-item" :disabled="false" icon="fa-regular fa-folder-open">
        <operaciones-resumen-tab-documentos :documentos="model?.Documentos!" :idOperacion="model!.Id" @documentoSubido="onDocumentoSubido"></operaciones-resumen-tab-documentos>
      </DxItem>
      <DxItem :key="5" :title="tituloTab5" class="tab-item" :disabled="false" icon="fa-regular fa-handshake">
        <operaciones-resumen-tab-productos-contratados :model="model" :tramite="tramite"></operaciones-resumen-tab-productos-contratados>
      </DxItem>
      <DxItem :key="6" :title="tituloTab6" class="tab-item" :disabled="false" icon="fa-regular fa-comment-dots">
        <operaciones-resumen-tab-observaciones :model="model" :tramite="tramite" :idTramite="idTramite"></operaciones-resumen-tab-observaciones>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import OperacionesResumenTabDocumentos from '@/components/operaciones-energia/OperacionesEnergiaResumenTabDocumentos.vue';
import OperacionesResumenTabTitular from '@/components/operaciones-energia/OperacionesEnergiaResumenTabTitular.vue';
import OperacionesResumenTabSuministro from '@/components/operaciones-energia/OperacionesEnergiaResumenTabSuministro.vue';
import OperacionesResumenTabFacturacion from '@/components/operaciones-energia/OperacionesEnergiaResumenTabFacturacion.vue';
import OperacionesResumenTabProductosContratados from '@/components/operaciones-energia/OperacionesEnergiaResumenTabProductosContratados.vue';
import OperacionesResumenTabObservaciones from '@/components/operaciones-energia/OperacionesEnergiaResumenTabObservaciones.vue';
import { computed } from 'vue';
import { type DetailOperacionEnergiaModel, TipoSuministroTramiteEnergiaEnum } from '@/.shared/.api';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import { useIntl } from '@/.shared/services/i18n/i18nservice';

const intl = useIntl();

defineProps({
  model: Object as () => DetailOperacionEnergiaModel,
  tramite: String as () => TipoSuministroTramiteEnergiaEnum,
  idTramite: String as () => String,
});

const emit = defineEmits(['documentoSubido']);

const tituloTab1 = computed(() => `${intl.i18n.t('operaciones.form.datos_del_titular')}`);
const tituloTab2 = computed(() => `${intl.i18n.t('operaciones.form.direccion_datos_suministro')}`);
const tituloTab3 = computed(() => `${intl.i18n.t('operaciones.form.datos_facturacion')}`);
const tituloTab4 = computed(() => `${intl.i18n.t('operaciones.form.documentacion')}`);
const tituloTab5 = computed(() => `${intl.i18n.t('operaciones.form.productos_contratados')}`);
const tituloTab6 = computed(() => `${intl.i18n.t('operaciones.form.observaciones')}`);

const onDocumentoSubido = () => {
  emit('documentoSubido');
};

</script>